import React, { useEffect, useState } from "react";
import CommonInputField from "../components/BrandsPartnerComponents/common_input_field";
import EmailIcon from "../components/BrandsPartnerComponents/email_icon";
import { BrandsType } from "./dtos/brands.dtos";
import { Form } from "antd";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";
import { checkPocEmail } from "../../API/endpoints/Email";
import PhoneInputWithCountryCode from "../components/BrandsPartnerComponents/PhoneFieldWithCountryCode";
import { GetCountries } from "../../API/endpoints/Common";
const countryData = require("country-codes-list");


type Props = {
  data: BrandsType;
  setData: React.Dispatch<React.SetStateAction<BrandsType>>;
  previousStep: () => void;
  nextStep: () => void;
  isMobile?: boolean;
};



const MainPointOfContactPage: React.FC<Props> = ({
  data,
  setData, previousStep, nextStep, isMobile
}) => {

  const [countryCodes, setCountryCodes] = useState<any[]>([]);

  const [phoneError, setPhoneError] = useState("");
  // Fetch country codes
  useEffect(() => {
    (async () => {
      try {
        const response = await GetCountries();

        const deduped = response.data.filter(
          (item: any, index: number, self: any[]) =>
            index ===
            self.findIndex((t) => t.country_code === item.country_code)
        );
        setCountryCodes(
          deduped.map((item: any) => ({
            value: item.country_code,
            label: item.country__alpha_code,
          }))
        );
      } catch (error) { }
    })();
  }, []);

  const [form] = Form.useForm();


  const handleSubmit = () => {
    let phoneErrorMsg = "";
  
    if (!data.contact_number_code && !data.contact_number) {
      phoneErrorMsg = "Country code & phone number are required.";
    } else if (!data.contact_number_code) {
      phoneErrorMsg = "Country code required.";
    } else if (!data.contact_number) {
      phoneErrorMsg = "Phone number required.";
    }
  
    setPhoneError(phoneErrorMsg);
    form
      .validateFields()
      .then((values) => {
        // Merge form values into main data
        setData((prev) => ({
          ...prev,
          ...values,
        }));
  
      // ✅ Proceed to next step
      })
      .catch((err) => {
        console.log("AntD form validation failed:", err);
      });
  
    if (phoneErrorMsg) {
      // Stop here if there's a phone error
      return;
    }
  
   
  
        nextStep(); // ✅ Proceed to next step
     
  };
  
  

  useEffect(() => {
    form.setFieldsValue(data);
  }, [data]);

  return (
    <div className="w-full max-w-[686px]">
      <div className="common-title pb-[12px]">Who’s Our Main Point of Contact?</div>
      <div className="common-sub-text pb-[60px]">A smooth journey starts with the right connection. Let us know who we should reach out to for all things related to your brand expansion.</div>

      {/* Grid Container */}
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSubmit}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-[16px] gap-y-[16px]">
          {/* Full Name */}
          <div className="col-span-1">
            <Form.Item
              name="first_name"
              rules={[{ required: true, message: "Full Name is required" }]}
            >   <CommonInputField
                label="Full Name"
                // placeholder="Full Name"
                value={data.first_name}
                // onChange={(e) => setFullNameValue(e.target.value)}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    first_name: e.target.value,
                  }))
                }
              /></Form.Item>
          </div>

          {/* Your Designation */}
          <div className="col-span-1">
            <Form.Item
              name="designation"
              rules={[{ required: true, message: "Your Designation is required" }]}
            >   <CommonInputField
                label="Your Designation"
                // placeholder="Brand Manager"
                value={data.designation}
                // onChange={(e) => setDesignationValue(e.target.value)}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    designation: e.target.value,
                  }))
                }
              /></Form.Item>
          </div>

          {/* Email */}
          <div className="col-span-1">
            <Form.Item
              name="email_id"
              rules={[
                { required: true, message: "Email is required" },
              // { type: "email", message: "Enter a valid email" },
              {
                validator: async (_, value) => {
                  if (!value) return Promise.resolve(); // Skip if empty; handled by "required"

                  try {
                    const res = await checkPocEmail({ poc_email: value });
                    console.log("Email validation response:", res); // Debugging output
                    if (res?.msg !== "Email accepted") {
                      return Promise.reject(res.msg || "Invalid email");
                    }
                    return Promise.resolve();
                  } catch (err) {
                    const message = typeof err === "object" && err !== null && "msg" in err
                      ? (err as { msg: string }).msg
                      : "Something went wrong";
                    return Promise.reject(`${message || ""}, Failed to validate email.`);
                  }
                },
              },
              ]}
            >  <CommonInputField
                label="Email"
                type="email"
                prefix={<div className="pr-[8px]"><EmailIcon /></div>}
                // placeholder="john.doe@example.com"
                value={data.email_id}
                // onChange={(e) => setEmailValue(e.target.value)}
                onChange={(e) =>
                  setData((curret) => ({
                    ...curret,
                    email_id: e.target.value,
                  }))
                }
              /></Form.Item>
          </div>

          {/* Phone */}
         
            
              {/* Actual phone input UI */}
              <div className="col-span-1  gap-0">
                <PhoneInputWithCountryCode
                  label="Phone"
                  error={phoneError}
                  countryCode={data.contact_number_code || ""}
                  onCountryCodeChange={(e) =>
                    setData((current) => ({
                      ...current,
                      contact_number_code: e,
                    }))
                  }
                  phoneNumber={data.contact_number || ""}
                  onPhoneNumberChange={(e) =>
                    setData((current) => ({
                      ...current,
                      contact_number: e,
                    }))
                  }
                  countryOptions={countryCodes}
                />
                  {/* This hidden Form.Item lets us validate phone via form system */}
              {/* <Form.Item
                name="phone_validation"
                 className="m-0 p-0 h-0"
                rules={[
                  {
                    validator: async () => {
                      if (!data.contact_number_code && !data.contact_number) {
                        throw new Error("Country code & phone number are required.");
                      }
                      if (!data.contact_number_code) {
                        throw new Error("Country code required.");
                      }
                      if (!data.contact_number) {
                        throw new Error("Phone number required.");
                      }
                    },
                  },
                ]}
                style={{ marginTop: 0 ,height: 0, padding: 0}}
              >
                 <div className="m-0 p-0 h-0" />
              </Form.Item> */}


              </div>
              </div>
            {/* </Form.Item> */}
          </Form>

      {/* Desktop Next/Previous Navigation */}
      {!isMobile && (
        <div className="mt-[60px]   inline-flex flex justify-start gap-x-[8px] w-full md:w-auto">
          <NavigationButton
            onClick={previousStep}
            label="Previous"
            type="text"
          />

          <NavigationButton
           onClick={handleSubmit}

            label={"Next"}
            type="primary"
          />
        </div>
      )}

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 flex justify-center px-4 py-4 gap-x-2 w-full shadow-lg z-20 bg-white">
          {
            <NavigationButton
              onClick={previousStep}
              label="Previous"
              type="text"
              block
            />
          }
          <NavigationButton
          onClick={handleSubmit}

            label={"Next"}
            type="primary"
            block
          />
        </div>
      )}
    </div>
  );
};

export default MainPointOfContactPage;
